import * as React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import Bs4Criteria from './Bs4Criteria'
import Bs4CriteriaSummary from './Bs4CriteriaSummary'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4I18N from '../Bs4I18N';

import * as Bs4Utils from '../Bs4Components/Bs4Utils'
import { getBoxSx, UxAccordion, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';
import Bs4ReportGeneric from './Bs4ReportGeneric';

const TYPE_BS4REPORT = 'type_Bs4ReportTypeCalendar';
const NAME_BS4REPORT = 'Bs4ReportTypeCalendar';

//Kalendarz, Terminarz
export default class Bs4ReportTypeCalendar extends Bs4ReportGeneric {    

  createModel() {    
    super.createModel();    
    this.setColumnsMenu();   
  }

  /////////////////// form field /////////////////////////////
  getValue() {
    return null;
  }

  resetOriginalValue() {
  }  

  isDifferentValues (oldValue, newVaue) {
    return false;
  }

  clear() {
  }
  //////////////////////////////////////////////////////////

  defaultUxTemplate = {
    class: 189,
    name: NAME_BS4REPORT,
    body: {
      Report35: {          
        event: {
          // margin: 1,
          // padding: 1,
          // elevation: 2,
          // borderRadius: 2,
        },        
        options: {
          margin: 0,
          padding: 1,
          elevation: 2,
          borderRadius: 2,
          minWidth: 200,
        },
      }        
    }
  };

  isSelected = (footer, view, type) => {
    if (view.type !== type) return false;    
    if (!Array.isArray(footer?.[type])) return false;
    return footer?.[type]?.includes(view.id)
  }

  getSelectedIdArray() {
    console.log('== Error === Bs4GenericReport == getSelectedIdArray - not implemented')
    return []
  }

  getUxTemplateEditor = (uxEditor) => {    
    const report = this;
    const type = TYPE_BS4REPORT;
    const eds = [{
      label: Bs4I18N.getTT('Zdarzenie', 'Event', 'Bs4ReportType35'),
      types: [TYPE_BS4REPORT],
      onReset: () => this.uxTemplate.body.Report35.event = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report35.event)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report35;
        
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.event} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.event} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.event} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.event} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='borderWidth'/>

            {/* <uxEditor.ViewCssText types={type} value={uxBody.event} name='minWidth'/> */}
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.event} name='padding'/>
          </Box>
        );
      },
    },
    
    {
      label: Bs4I18N.getTT('Menu options', 'Opcje menu', 'Bs4ReportType35'),
      types: [TYPE_BS4REPORT],
      onReset: () => this.uxTemplate.body.Report35.options = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Report35.options)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Report35;
        
        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.options} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.options} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.options} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.options} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='borderWidth'/>

            <uxEditor.ViewCssText types={type} value={uxBody.options} name='minWidth'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.options} name='padding'/>
          </Box>
        );
      },
    }];
    
    return [{
      label: Bs4I18N.getTT('Report35', 'Report35', 'Bs4ReportType35'),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4REPORT],
      Content: (props) => {
        const [expanded, setExpanded] = React.useState(eds[0].label);
        
        const handleChange = (panel) => (event, isExpanded) => {
          // console.log('... UxAccordion .Main. .handleChange.', panel, isExpanded)
          setExpanded(isExpanded ? panel : false);
        };
  
        // console.log('... UxAccordion .Main.', props)

        return (
          <React.Fragment>
            {eds.map((ux, index) => {
              return (
                <UxAccordion
                  key={index} 
                  label={ux.label} 
                  types={ux.types}
                  expanded={expanded} 
                  onChange={handleChange} 
                  onReset={ux.onReset}
                >
                  <ux.Content />
                </UxAccordion>
              )
            })}
          </React.Fragment>
        )
      },
    }]    
  }

  handleReportIconShow = (e) => {
    console.log('.........ReportIconShow.....')
    this.remembersettings = false;
    this.reloadAll();
  }

  handleReportIconRemember = (e) => {
    console.log('.........ReportIconRemember.....')
    this.remembersettings = true;
    this.reloadAll();
  }

  handleReportIconReset = (e) => {
    console.log('.........ReportIconReset.....')
    this.remembersettings = false;
    Bs4MainDispatch.commandParser('Bs4PrefsReset', { 
      js_ForgetOptionId: this.optionId, 
      currFormId: this.formId,
    }, this.bs4KartotekaId);    
    this.clearAllCriteria();
    this.reloadAll();
  }

  handleRowClick = (bs4Event) => {    
    if (Bs4MainDispatch.commandParserAfter(this.bs4KartotekaId)) {
      console.log('...Bs4ReportTypeCalendar...handleRowClick...commandParserAfter', bs4Event)
    } else if(this.getPageParam('row_active_click')) {
      console.log('...Bs4ReportTypeCalendar...handleRowClick...row_active_click', bs4Event)
      Bs4MainDispatch.commandParser('Bs4RowClick',{ rowObjectId: bs4Event.id, currFormId: this.formId }, this.bs4KartotekaId);
    }	
  }

  handleBs4EventAdd = (info) => {
    Bs4MainDispatch.commandParser('Bs4CalendarAdd', {
      EventSchStart: Bs4Utils.toDateTime(info.start), 
      EventSchEnd: Bs4Utils.toDateTime(info.end),
      currFormId: this.formId,
    },  this.bs4KartotekaId);        
  }
  
  handleBs4EventResize = (bs4Event) => {
    Bs4MainDispatch.commandParser('Bs4CalendarMove', {
      EventSchId: bs4Event.id, 
      EventSchStart: Bs4Utils.toDateTime(bs4Event.start), 
      EventSchEnd: Bs4Utils.toDateTime(bs4Event.end) , 
      resTargetId : bs4Event.ResourceId, 
      currFormId: this.formId, 
    }, this.bs4KartotekaId); 
  }

  handleBs4EventDrop = (bs4Event) => {
    Bs4MainDispatch.commandParser('Bs4CalendarMove', {
      EventSchId: bs4Event.id, 
      EventSchStart: Bs4Utils.toDateTime(bs4Event.start), 
      EventSchEnd: Bs4Utils.toDateTime(bs4Event.end), 
      resTargetId : bs4Event.ResourceId,
      currFormId: this.formId, 
    }, this.bs4KartotekaId);
  }
  
// polecenie wykonywane po kliknieciu na pozycje w menu na stronie typu zestawienie
	runListOption(item) { 
    // console.log('...runListOption...', item, this.selectedRowsId, this)
		const details = { 
			reportOptionId: item?.bs4Id, 
			selectedRows: this.selectedRowsId,			
      currFormId: this.formId,
		}

		Bs4MainDispatch.commandParser('Bs4ReportOption', details, this.bs4KartotekaId, {
      _Typ: Bs4MainDispatch.ASK_TO_CONFIRM,
      ok: () => {},
      cancel: () => this.reload(),
    });

    this.selectedRowsId = [];
    this.atrybProgressbar(item);
	}

  handleMenuClickEvent = (item, event) => {
    this.selectedRowsId = [event?.id];
    this.runListOption(item);
  }  

  reload = () => {
    this.remembersettings = false;
    this.reloadAll()
  }

  reloadAll = () => {    
    console.log('=== Error === reloadAll not implemented');
  }

  packColumnLayout = () => {
    return null;
  }

  fetchCriteriaVals = (bs4CalendarData) => {
    const filterCriteria = this.defaultCriteriaVals();
    filterCriteria.startDateIso = Bs4Utils.toDate(bs4CalendarData.start);
    filterCriteria.endDateIso = Bs4Utils.toDate(bs4CalendarData.end);
    filterCriteria.DateScope = bs4CalendarData.viewType;
    if (this.remembersettings) {
      filterCriteria.remembersettings = 1;    
      filterCriteria.newGridDesign = this.packColumnLayout();	// zapamietany uklad kolumn
    }
    return filterCriteria;
  }
  
  fetchMore = (bs4CalendarData, successCallback, failureCallback) => {
    const criteriaVals = this.fetchCriteriaVals(bs4CalendarData);
    const newCriteriaVals = Bs4MainDispatch.getParserParams(criteriaVals, this.bs4KartotekaId);
    const formData = new FormData();
    for (let [key, value] of Object.entries(newCriteriaVals)) formData.append(key, value);
    fetch(Bs4MainDispatch.getUrlPath('web.php?com=Bs4ReportData'), {method: 'POST', body: formData})
    .then(response => {
      return response.text();
    })
    .then(returnedText => {
      try {        
        const returnedJson = JSON.parse(returnedText);
        // console.log('...fetchMore...', newCriteriaVals, returnedJson);
        Bs4MainDispatch.speedRun((tag) => {      
          console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId));
        }, 'TypeCalendar.More');
        Bs4MainDispatch.parsingBs4Response(returnedJson, this.bs4KartotekaId);
        successCallback(returnedJson.res, returnedJson.evts);
      } catch (error) {
        console.log(returnedText);
        console.log(error);
        failureCallback(error)
      }
    })
    .catch((error) => {
      console.log(error);
      failureCallback(error)
    });
  }
    
  setScrollTarget = (target) => {  
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    console.log('...setScrollTarget35...', target, bs4Kartoteka)
    if (bs4Kartoteka) bs4Kartoteka.setScrollTarget(target, 'grid');
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORT);
    const [uxBodyEvent, uxBodyFooter, uxBodyOption] = React.useMemo(() => {
      return [{...this.uxTemplate.body.Report35.event}, {...this.uxTemplate.body.Report35.footer}, {...this.uxTemplate.body.Report35.options}];
    }, [dateTimeStamp]);

    // console.log('...TYPE_BS4REPORT...', );
    
    return (
      <Box 
        ref={ref} 
        //height='100%' 
        width='100%' 
        display='flex' 
        flexDirection="column"
        px={props.uxKartoteka?.spacing}
      >        
        <report.ReportBs4HorizontalMenu 
          bs4Menu={report.menuItems}
          onMenuClick={report.handleMenuClick} 
        />
        <Box display="flex" flexDirection="row" flexWrap='wrap' gap='6px' p={0.5} alignItems='center'>
          <Bs4Criteria {...report.props}/>
        </Box>
        <Box pt={props.uxKartoteka?.spacing / 3}/>
        <Bs4CriteriaSummary {...report.props}/>
        <report.bs4ReportTimeline.ViewComponent
          columnsMenu={report.columnsMenu} 
          uxBodyEvent={uxBodyEvent}
          uxBodyFooter={uxBodyFooter}
          uxBodyOption={uxBodyOption}
          onMenuClick={report.handleMenuClickEvent}
          fetchMore={report.fetchMore}
          onShow={report.handleReportIconShow}
          onRemember={report.handleReportIconRemember}
          onReset={report.handleReportIconReset}
          viewButtons={report.viewButtons}
          onRowClick={report.handleRowClick}
          bs4EventResize = {report.handleBs4EventResize}
          bs4EventDrop = {report.handleBs4EventDrop}
        />
      </Box>
    )
  });
}
